import { CLASSES } from "@/scripts/helpers/constants";

export const initLoader = selector => {
  const { LOADER, LOADER_WRAPPER, ACTIVE } = CLASSES;
  // Possible to have several loaders
  // If no selector passed on, find closest and use it globally
  const loader = (selector && $(selector)) || $(`.${LOADER}`);
  const loaderWrapper = loader.closest(`.${LOADER_WRAPPER}`);
  const layout = $("body");

  if (loader.length && layout.length) {
    if (!loaderWrapper.length) layout.addClass(LOADER_WRAPPER);

    loader.addClass(ACTIVE);
  }
};

const renderLoader = (modifier = null) => {
  const modifierClass = modifier !== null ? modifier : "";

  return `
    <div class="loader ${modifierClass}">
        <div class="loader__icon"></div>
        <div class="loader__text">Hang in there...</div>
    </div>
  `;
};

export const generateLoaderMarkup = (wrapperClass, loaderName) => {
  $(`.${wrapperClass}`).append(renderLoader(loaderName));
  initLoader(`.${loaderName}`);
};

export const hideLoader = selector => {
  const { LOADER, LOADER_WRAPPER, ACTIVE } = CLASSES;

  const loader = (selector && $(selector)) || $(`.${LOADER}`);
  const layout = $("body");

  if (loader.length && loader.hasClass(ACTIVE)) loader.removeClass(ACTIVE);

  if (layout.length && layout.hasClass(LOADER_WRAPPER))
    layout.removeClass(LOADER_WRAPPER);
};
